<template>
  <v-container
    id="regular-tables"
    fluid
    tag="section"
  >
    <v-menu
      v-if="isMobile"
      offset-x
      right
    >
      <template #activator="{ on, attrs }">
        <v-icon
          dark
          large
          color="#37474F"
          v-bind="attrs"
          v-on="on"
        >
          mdi-menu
        </v-icon>
      </template>
      <v-list
        nav
        dense
      >
        <v-list-item-group
          v-model="selectedItem"
          color="#37474F"
          mandatory
        >
          <v-list-item
            link
            @click="getDigiBoardsList()"
          >
            <v-list-item-icon>
              <v-icon style="font-size:25px;color:#37474F;font-weight:bold;">
                mdi-monitor-dashboard
              </v-icon>
            </v-list-item-icon>
            <v-list-item-title
              style="font-size:14px;color:#37474F;font-weight:bold;"
            >
              DigiBoards List
            </v-list-item-title>
          </v-list-item>
          <v-list-item
            link
            @click="getTimeSlotsList()"
          >
            <v-list-item-icon>
              <v-icon style="font-size:25px;color:#37474F;font-weight:bold;">
                mdi-calendar-clock
              </v-icon>
            </v-list-item-icon>
            <v-list-item-title
              style="font-size:14px;color:#37474F;font-weight:bold;"
            >
              Time Slots
            </v-list-item-title>
          </v-list-item>
          <v-list-item
            link
            @click="getDigiBoardTypesList()"
          >
            <v-list-item-icon>
              <v-icon style="font-size:25px;color:#37474F;font-weight:bold;">
                mdi-monitor-cellphone
              </v-icon>
            </v-list-item-icon>
            <v-list-item-title
              style="font-size:14px;color:#37474F;font-weight:bold;"
            >
              DigiBoard Types
            </v-list-item-title>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-menu>
    <v-navigation-drawer
      v-if="!isMobile"
      permanent
      color="#ECEFF1"
      expand-on-hover
      absolute
      bottom
      floating
    >
      <v-list>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title class="nav-title-style">
              <v-list-item-icon>
                <v-icon
                  style="font-size:25px;color:#37474F;font-weight:bold;"
                >
                  mdi-monitor-multiple
                </v-icon>
              </v-list-item-icon>
              DigiBoards
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-divider />
      <br>
      <v-list
        nav
        dense
      >
        <v-list-item-group
          v-model="selectedItem"
          color="#37474F"
          mandatory
        >
          <v-list-item
            link
            @click="getDigiBoardsList()"
          >
            <v-list-item-icon>
              <v-icon style="font-size:25px;color:#37474F;font-weight:bold;">
                mdi-monitor-dashboard
              </v-icon>
            </v-list-item-icon>
            <v-list-item-title
              style="font-size:14px;color:#37474F;font-weight:bold;"
            >
              DigiBoards List
            </v-list-item-title>
          </v-list-item>
          <v-list-item
            link
            @click="getTimeSlotsList()"
          >
            <v-list-item-icon>
              <v-icon style="font-size:25px;color:#37474F;font-weight:bold;">
                mdi-calendar-clock
              </v-icon>
            </v-list-item-icon>
            <v-list-item-title
              style="font-size:14px;color:#37474F;font-weight:bold;"
            >
              Time Slots
            </v-list-item-title>
          </v-list-item>
          <v-list-item
            link
            @click="getDigiBoardTypesList()"
          >
            <v-list-item-icon>
              <v-icon style="font-size:25px;color:#37474F;font-weight:bold;">
                mdi-monitor-cellphone
              </v-icon>
            </v-list-item-icon>
            <v-list-item-title
              style="font-size:14px;color:#37474F;font-weight:bold;"
            >
              DigiBoard Types
            </v-list-item-title>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
    <div>
      <digiboards-list v-if="showDigiBoardsList" />
      <time-slots-list v-if="showTimeSlotsList" />
      <digi-board-types-list v-if="showDigiBoardTypesList" />
    </div>
  </v-container>
</template>

<script>
  import DigiBoardsList from './DigiBoardsList.vue';
  import TimeSlotsList from './timeslots/TimeSlotsList.vue';
  import DigiBoardTypesList from './digiboardtypes/DigiBoardTypesList.vue';

  export default {
    name: 'Users',
    components: {
      'digiboards-list': DigiBoardsList,
      'time-slots-list': TimeSlotsList,
      'digi-board-types-list': DigiBoardTypesList,
    },
    data: () => ({
      selectedItem: -1,
      showDigiBoardsList: true,
      showTimeSlotsList: false,
      showDigiBoardTypesList: false,
    }),
    computed: {
      isMobile () {
        if (this.$vuetify.breakpoint.md || this.$vuetify.breakpoint.lg || this.$vuetify.breakpoint.xl) {
          return false;
        } else {
          return true;
        }
      },
    },
    mounted () {
      this.selectedItem = 0;
    },
    methods: {
      getDigiBoardsList () {
        this.showTimeSlotsList = false;
        this.showDigiBoardTypesList = false;
        this.showDigiBoardsList = true;
      },
      getTimeSlotsList () {
        this.showDigiBoardsList = false;
        this.showDigiBoardTypesList = false;
        this.showTimeSlotsList = true;
      },
      getDigiBoardTypesList () {
        this.showDigiBoardsList = false;
        this.showTimeSlotsList = false;
        this.showDigiBoardTypesList = true;
      },
    },
  };

</script>
<style scoped>
.nav-title-style {
  font-family: 'Times New Roman', Times, serif;
  font-weight: bold;
  color: #37474F;
  font-size: 25px;
}
</style>
